import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import Icon from "@components/icon";
import OuterClickListener from "@components/outer-click-listener";

import Avatar from "./components/Avatar";

import UserInformation from "./components/UserInformation";
import ProfileDropdown from "./components/ProfileDropdown";

import { useStore } from "../../connect";

import styles from "./Profile.scss";

const cx = classnames.bind(styles);

const isSafari =
  process.env.PRERENDER === "1"
    ? false
    : navigator.platform.toLowerCase().includes("mac");

const Profile = () => {
  const { adaptive, header, profile } = useStore();

  if (adaptive.isLargeMobile || adaptive.isMobile) {
    return null;
  }

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    header.toggleUserMenu();
  };

  if (profile.noProfile) {
    return (
      <div className={cx("profile")}>
        <div className={cx("profile-area")}>
          <Avatar />
          {!adaptive.isTablet && <UserInformation />}
        </div>
      </div>
    );
  }

  return (
    <div className={cx("profile")}>
      <button
        className={cx("profile-button", {
          active: header.openedDropdown === "profile",
        })}
        onClick={handleClick}
      >
        <Avatar />

        {adaptive.isDesktop && <UserInformation />}
        <Icon
          name={header.showMenu ? "ic_arrow-up-out" : "ic_arrow-down-out"}
          size="s"
          color="var(--glz-color-neutral-tone-5)"
          className={cx("arrow")}
        />
      </button>
      {header.openedDropdown === "profile" && (
        <OuterClickListener
          className={cx("dropdown-wrapper")}
          onClickOutside={() => header.toggleUserMenu(false)}
        >
          <div className={cx("profile-dropdown", { "is-safari": isSafari })}>
            <ProfileDropdown isMobile={false} />
          </div>
        </OuterClickListener>
      )}
    </div>
  );
};

export default observer(Profile);
